import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const createEmailCampaign = "/marcom/email/create";
const createUserEmailTemplate = "/marcom/email/createUserEmailTemplate";
const getAllEmailTemplate = "/marcom/email/getAllEmailTemplate";
const getEmailConfig = "/marcom/email/getEmailConfig";

export default {
  createEmailCampaign(payload) {
    return Repository.post(`${createEmailCampaign}`, payload);
  },
  createUserEmailTemplate(payload) {
    return Repository.post(`${createUserEmailTemplate}`, payload);
  },
  getAllEmailTemplate(payload) {
    return Repository.post(`${getAllEmailTemplate}`, payload);
  },
  getEmailConfig(payload) {
    return Repository.post(`${getEmailConfig}`, payload);
  },
};
